<template>
  <div class="mainC">
    <ul class="list-group MobileHide pl-0 pr-0">
      <b-spinner
        variant="success"
        label="Spinning"
        style="
          width: 3rem;
          height: 3rem;
          margin: auto;
          margin-top: 20px;
          margin-bottom: 20px;
        "
        v-if="spinning"
      ></b-spinner>
      <div v-for="(tourid, j) in tourOrder" :key="j">
        <li
          class="list-group-item"
          v-if="tournaments[tourid].live && cookiesObject.token"
          style="background: #212225; color: white; margin: auto"
        >
          <router-link
            style="color: white"
            id="router-link-league"
            :to="{
              name: 'LeaguePageNav',
              params: {
                leagueId: tournaments[tourid].matches[0].tournament.id,
              },
            }"
          >
            <img
              :src="
                leagueLogo +
                tournaments[tourid].matches[0].tournament.category.id
              "
              style="width: 17px; margin-right: 5px"
              alt=""
            />
            {{
              tournaments[tourid].matches[0].tournament.name
                | transliterate(cookiesObject.lang)
            }}
          </router-link>
        </li>
        <li
          class="list-group-item"
          v-else-if="tournaments[tourid].live && !cookiesObject.token"
          style="background: #212225; color: white; margin: auto"
          data-toggle="modal"
          data-target="#exampleModal"
        >
          <img
            :src="
              leagueLogo + tournaments[tourid].matches[0].tournament.category.id
            "
            style="width: 17px; margin-right: 5px"
            alt=""
          />
          <span style="cursor: pointer">{{
            tournaments[tourid].matches[0].tournament.name
              | transliterate(cookiesObject.lang)
          }}</span>
        </li>
        <div v-for="(game, i) in tournaments[tourid].matches" :key="i">
          <div v-if="cookiesObject.token">
            <li
              style="background: #141416"
              class="list-group-item game"
              v-if="
                game.matchStatus.name == 'LIVE' || game.matchStatus.name == 'HT'
              "
            >
              <div class="row">
                <router-link
                  style="color: white"
                  class="col"
                  id="router-link"
                  :to="{ name: 'MatchPagePar', params: { gameId: game.id } }"
                >
                  <div class="row">
                    <div class="col-1 bodyElement">
                      <p v-if="game.matchStatus.name == 'LIVE'" class="pop">
                        Live {{ calculateMinutes(game.counterStartTime) }}'
                      </p>
                      <p v-else-if="game.matchStatus.name == 'HT'">HT</p>
                    </div>
                    <div
                      class="col bodyElement"
                      :style="
                        rtl
                          ? 'margin-top: -5px; text-align: right;'
                          : 'margin-top: -5px; text-align: left;'
                      "
                    >
                      {{
                        game.team1.name.slice(0, 22)
                          | transliterate(cookiesObject.lang)
                      }}
                      <img
                        :src="teamLogo + game.team1.id"
                        alt=""
                        style="width: 20px"
                      />
                    </div>
                    <div class="col-2 bodyElement" style="letter-spacing: 3px">
                      {{
                        game.currentScore | transliterate(cookiesObject.lang)
                      }}
                    </div>
                    <div
                      class="col bodyElement"
                      :style="
                        rtl
                          ? 'margin-top: -5px; text-align: left;'
                          : 'margin-top: -5px; text-align: right;'
                      "
                    >
                      <img
                        :src="teamLogo + game.team2.id"
                        alt=""
                        style="width: 20px"
                      />
                      {{
                        game.team2.name.slice(0, 22)
                          | transliterate(cookiesObject.lang)
                      }}
                    </div>
                  </div>
                </router-link>
                <div class="col-1 bodyElement">
                  <div>
                    <b-btn
                      v-if="favsTe.some((fav) => fav.id === game.id)"
                      v-on:click="
                        removeFavorite({ value: game.id, type: match })
                      "
                      style="
                        float: right;
                        background: none;
                        width: 5px;
                        height: 5px;
                        border: none;
                      "
                    >
                      <img
                        src="@/assets/orStar.png"
                        style="
                          width: 15px;
                          margin-top: -30px;
                          margin-left: -10px;
                        "
                        alt=""
                      />
                    </b-btn>
                    <b-btn
                      v-else
                      v-on:click="
                        addToFavorites({ value: game.id, type: match })
                      "
                      style="
                        float: right;
                        background: none;
                        width: 5px;
                        height: 5px;
                        border: none;
                      "
                    >
                      <img
                        src="@/assets/favorite.svg"
                        style="
                          width: 15px;
                          margin-top: -30px;
                          margin-left: -10px;
                        "
                        alt=""
                      />
                    </b-btn>
                  </div>
                </div>
              </div>
            </li>
          </div>
          <div
            v-else
            data-toggle="modal"
            data-target="#exampleModal"
            style="cursor: pointer"
          >
            <li
              style="background: #141416; color: white"
              class="list-group-item game"
              v-if="
                game.matchStatus.name == 'LIVE' || game.matchStatus.name == 'HT'
              "
            >
              <div class="row">
                <div class="col-1 bodyElement">
                  <p v-if="game.matchStatus.name == 'LIVE'" class="pop">
                    Live {{ calculateMinutes(game.counterStartTime) }}'
                  </p>
                  <p v-else-if="game.matchStatus.name == 'HT'">HT</p>
                </div>
                <div
                  class="col bodyElement"
                  :style="
                    rtl
                      ? 'margin-top: -5px; text-align: left;'
                      : 'margin-top: -5px; text-align: right;'
                  "
                >
                  {{
                    game.team1.name.slice(0, 22)
                      | transliterate(cookiesObject.lang)
                  }}
                  <img
                    :src="teamLogo + game.team1.id"
                    alt=""
                    style="width: 20px"
                  />
                </div>
                <div class="col-2 bodyElement" style="letter-spacing: 3px">
                  {{ game.currentScore | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col bodyElement"
                  :style="
                    rtl
                      ? 'margin-top: -5px; text-align: right;'
                      : 'margin-top: -5px; text-align: left;'
                  "
                >
                  <img
                    :src="teamLogo + game.team2.id"
                    alt=""
                    style="width: 20px"
                  />
                  {{
                    game.team2.name.slice(0, 22)
                      | transliterate(cookiesObject.lang)
                  }}
                </div>
                <div class="col-1 bodyElement">
                  <div>
                    <b-btn
                      style="
                        float: right;
                        background: none;
                        width: 5px;
                        height: 5px;
                        border: none;
                      "
                    >
                      <img
                        src="@/assets/favorite.svg"
                        style="
                          width: 15px;
                          margin-top: -30px;
                          margin-left: -10px;
                        "
                        alt=""
                      />
                    </b-btn>
                  </div>
                </div>
              </div>
            </li>
          </div>
        </div>
      </div>
    </ul>
    <ul class="list-group MobileShow pl-0 pr-0">
      <b-spinner
        variant="success"
        label="Spinning"
        style="
          width: 3rem;
          height: 3rem;
          margin: auto;
          margin-top: 20px;
          margin-bottom: 20px;
        "
        v-if="spinning"
      ></b-spinner>
      <div v-for="(tourid, j) in tourOrder" :key="j">
        <li
          class="list-group-item"
          v-if="tournaments[tourid].live && cookiesObject.token"
          style="background: #212225"
        >
          <router-link
            id="router-link-league"
            style="color: lightgrey"
            :to="{
              name: 'LeaguePageNav',
              params: {
                leagueId: tournaments[tourid].matches[0].tournament.id,
              },
            }"
          >
            <img
              :src="
                leagueLogo +
                tournaments[tourid].matches[0].tournament.category.id
              "
              style="width: 17px; margin-right: 5px; margin-top: -2px"
              alt=""
            />
            {{
              tournaments[tourid].matches[0].tournament.name
                | transliterate(cookiesObject.lang)
            }}
          </router-link>
        </li>
        <li
          class="list-group-item"
          v-else-if="tournaments[tourid].live && !cookiesObject.token"
          style="background: #212225; color: lightgrey; line-height: 7px"
          v-b-modal.modal-multi-1
        >
          <img
            :src="
              leagueLogo + tournaments[tourid].matches[0].tournament.category.id
            "
            style="width: 17px; margin-right: 5px; margin-top: -2px"
            alt=""
          />
          <span style="cursor: pointer">{{
            tournaments[tourid].matches[0].tournament.name
              | transliterate(cookiesObject.lang)
          }}</span>
        </li>
        <div v-for="(game, i) in tournaments[tourid].matches" :key="i">
          <div v-if="cookiesObject.token">
            <li
              class="list-group-item game"
              style="background: #141416"
              v-if="
                game.matchStatus.name == 'LIVE' || game.matchStatus.name == 'HT'
              "
            >
              <div class="row">
                <div
                  class="col-1 bodyElement"
                  style="margin-top: 15px; margin-right: 5px"
                >
                  <p v-if="game.matchStatus.name == 'LIVE'" class="pop">
                    {{ calculateMinutes(game.counterStartTime) }}'
                  </p>
                  <p
                    v-else-if="game.matchStatus.name == 'HT'"
                    style="color: #e6e6e6"
                  >
                    HT
                  </p>
                </div>
                <router-link
                  class="col"
                  id="router-link"
                  :to="{ name: 'MatchPagePar', params: { gameId: game.id } }"
                >
                  <div class="row">
                    <div
                      class="col"
                      style="text-align: left; font-size: 14px; margin-top: 4px"
                    >
                      <div class="bodyElement" style="margin-bottom: 10px">
                        <img
                          :src="teamLogo + game.team1.id"
                          alt=""
                          style="width: 12px; margin-right: 4px"
                        />{{
                          game.team1.name.slice(0, 20)
                            | transliterate(cookiesObject.lang)
                        }}
                      </div>
                      <div class="bodyElement">
                        <img
                          :src="teamLogo + game.team2.id"
                          alt=""
                          style="width: 12px; margin-right: 4px"
                        />{{
                          game.team2.name.slice(0, 20)
                            | transliterate(cookiesObject.lang)
                        }}
                      </div>
                    </div>
                    <div class="col-1" style="margin-top: 4px">
                      <div style="margin-bottom: 15px">
                        {{
                          game.currentScore.slice(0, 1)
                            | transliterate(cookiesObject.lang)
                        }}
                      </div>
                      <div>
                        {{
                          game.currentScore.slice(2, 3)
                            | transliterate(cookiesObject.lang)
                        }}
                      </div>
                    </div>
                  </div>
                </router-link>
                <div class="col-1 bodyElement" style="margin-top: 4px">
                  <div>
                    <img
                      v-if="favsTe.some((fav) => fav.id === game.id)"
                      v-on:click="
                        removeFavorite({ value: game.id, type: match })
                      "
                      src="@/assets/orStar.png"
                      style="width: 16px; margin-top: 5px"
                      alt=""
                    />
                    <img
                      v-else
                      v-on:click="
                        addToFavorites({ value: game.id, type: match })
                      "
                      src="@/assets/favorite.svg"
                      style="width: 16px; margin-top: 5px"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </li>
          </div>
          <div v-else v-b-modal.modal-multi-1>
            <li
              class="list-group-item game"
              style="background: #141416; color: lightgrey"
              v-if="
                game.matchStatus.name == 'LIVE' || game.matchStatus.name == 'HT'
              "
            >
              <div class="row">
                <div
                  class="col-1 bodyElement"
                  style="margin-top: 15px; margin-right: 5px"
                >
                  <p v-if="game.matchStatus.name == 'LIVE'" class="pop">
                    {{ calculateMinutes(game.counterStartTime) }}'
                  </p>
                  <p v-else-if="game.matchStatus.name == 'HT'">HT</p>
                </div>
                <div
                  class="col"
                  style="text-align: left; font-size: 14px; margin-top: 4px"
                >
                  <div class="bodyElement" style="margin-bottom: 10px">
                    <img
                      :src="teamLogo + game.team1.id"
                      alt=""
                      style="width: 12px; margin-right: 4px"
                    />{{
                      game.team1.name.slice(0, 20)
                        | transliterate(cookiesObject.lang)
                    }}
                  </div>
                  <div class="bodyElement">
                    <img
                      :src="teamLogo + game.team2.id"
                      alt=""
                      style="width: 12px; margin-right: 4px"
                    />{{
                      game.team2.name.slice(0, 20)
                        | transliterate(cookiesObject.lang)
                    }}
                  </div>
                </div>
                <div class="col-1" style="margin-top: 4px">
                  <div style="margin-bottom: 15px">
                    {{
                      game.currentScore.slice(0, 1)
                        | transliterate(cookiesObject.lang)
                    }}
                  </div>
                  <div>
                    {{
                      game.currentScore.slice(2, 3)
                        | transliterate(cookiesObject.lang)
                    }}
                  </div>
                </div>
                <div class="col-1 bodyElement" style="margin-top: 4px">
                  <div>
                    <img
                      src="@/assets/favorite.svg"
                      v-b-modal.modal-multi-1
                      style="width: 16px; margin-top: 5px"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </li>
          </div>
        </div>
      </div>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Live",
  data() {
    return {
      games: [],
      gameId: "11886023",
      value: "",
      spinning: true,
      cookiesObject: "",
      leagueLogo: "https://sportapi.zuniac.com/category/logo/",
      teamLogo: "https://sportapi.zuniac.com/team/logo/",
      leagueId: "",
      leagueIden: "",
      TimeNow: "",
      match: "match",
      tournaments: {},
      tourOrder: [],
    };
  },
  async mounted() {
    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;

    if (this.cookiesObject.token) {
      this.getArray();
    }

    this.getData();

    setInterval(() => {
      this.getData();
    }, 50000);

    this.calculateMinutes();
  },

  beforeDestroy() {
    clearInterval(this.setInterval);
  },

  methods: {
    ...mapActions(["getArray", "removeFavorite", "addToFavorites"]),
    async getData() {
      var offset = new Date().getTimezoneOffset();

      if (this.cookiesObject.token) {
        const res = await fetch(
          this.httpReq +
            "/sport/matches?date=" +
            this.getDate1() +
            "&portalId=" +
            (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0) +
            "&sportId=1&timezone=%2B" +
            offset / -60 +
            "%3A00&token=" +
            this.cookiesObject.token
        );
        const data = await res.json();
        const games = data.matches;
        this.games = games;

        if (data.code == 200) {
          //everything is okay
        } else if (data.code == 401) {
          alert("Not Authorized, need to re sign in!");
          document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          document.cookie = "langId = 1";
          document.cookie = "lang = en";
          document.cookie =
            "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          document.cookie =
            "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          location.assign("/");
        } else if (data.code == 404) {
          alert("Token is not valid and portal id not provided");
          document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          document.cookie = "langId = 1";
          document.cookie = "lang = en";
          document.cookie =
            "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          document.cookie =
            "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          location.assign("/");
        } else if (data.code == 500) {
          alert("Oops, something went wrong!");
          document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          document.cookie = "langId = 1";
          document.cookie = "lang = en";
          document.cookie =
            "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          document.cookie =
            "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          location.assign("/");
        } else {
          alert("service error");
          document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          document.cookie = "langId = 1";
          document.cookie = "lang = en";
          document.cookie =
            "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          document.cookie =
            "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          location.assign("/");
        }
      } else {
        const res = await fetch(
          this.httpReq +
            "/sport/matches?date=" +
            this.getDate1() +
            "&langId=" +
            this.cookiesObject.langId +
            "&portalId=" +
            (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0) +
            "&sportId=1&timezone=%2B" +
            offset / -60 +
            "%3A00"
        );
        const data = await res.json();
        const games = data.matches;
        this.games = games;
      }

      const tournaments = {};
      const tourOrder = [];

      this.games.forEach((e) => {
        const tourid = e.tournament.id;

        if (typeof tournaments[tourid] === "undefined") {
          tournaments[tourid] = {
            matches: [],
            live: false,
          };
          tourOrder.push(tourid);
        }

        tournaments[tourid].matches.push(e);
        if (e.matchStatus.name == "LIVE" || e.matchStatus.name == "HT") {
          tournaments[tourid].live = true;
        }
      });

      this.tournaments = tournaments;
      this.tourOrder = tourOrder;

      this.spinning = false;
    },
    getDate1() {
      var dt = new Date();
      dt.setDate(dt.getDate());
      var fdDate = dt.getDate();
      var fdMonth = dt.getMonth() + 1;
      var fdYear = dt.getFullYear();

      if (fdMonth.toString().length == 1) {
        fdMonth = "0" + fdMonth;
      }
      if (fdDate.toString().length == 1) {
        fdDate = "0" + fdDate;
      }

      var fd = fdYear + "-" + fdMonth + "-" + fdDate;
      return fd;
    },
    calculateMinutes(value) {
      if (value == null) {
        return "LIVE";
      } else {
        var startDate = new Date(value.replace(" ", "T"));
        var endDate = Date.now();
        var difference = (endDate - startDate) / 1000 / 60;

        if (difference < 0) {
          difference = difference + 240;
        }

        return parseInt(difference);
      }
    },
  },
  components: {},
  props: {},
  computed: {
    ...mapGetters(["favsTe", "httpReq", "rtl"]),
  },

  watch: {},
};
</script>

<style scoped>
.pop {
  animation: color-change 1.2s infinite;
}
@keyframes color-change {
  0% {
    color: #a43d4a;
  }
  50% {
    color: red;
  }
  100% {
    color: #a43d4a;
  }
}
.mainC {
  margin-top: 2px;
  font-weight: 500;
}
#router-link {
  color: lightgray;
  text-decoration: none;
}

.container {
  margin-top: 12px;
}
#router-link-league {
  color: black;
  text-decoration: none;
}

li {
  line-height: 5px;
  border-radius: 0px !important;
  font-size: 12px;
}
.LeagueName {
  margin-bottom: 10px;
}

.header {
  background: #d6d6d6;
  color: white;
}

.bodyElement {
  padding: 0;
  height: 8px;
}

.game {
  text-align: center;
}
.gamebg :hover {
  background: #309a3d;
}

@media only screen and (max-width: 770px) {
  body {
    background: #212529;
  }
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}
</style>
